import FormattedMessage from 'I18n/components/FormattedMessage';
import { ErrorMessage } from 'foundations-components/transitional/components/ErrorMessage';
import FullPageError from './FullPageError';
import { jsx as _jsx } from "react/jsx-runtime";
const ErrorStatePage = ({
  'data-test-id': dataTestId,
  title,
  message
}) => /*#__PURE__*/_jsx(ErrorMessage, {
  "data-test-id": dataTestId,
  illustration: "empty-state-charts",
  title: /*#__PURE__*/_jsx("h4", {
    children: title
  }),
  marginBlockStart: "1300",
  children: message
});
export const EmptyStateError = () => /*#__PURE__*/_jsx(ErrorStatePage, {
  "data-test-id": "network-error-other",
  title: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "payments.errorState.unavailable.title"
  }),
  message: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "payments.errorState.unavailable.text"
  })
});
export const TemporarilyUnavailableError = () => /*#__PURE__*/_jsx(ErrorStatePage, {
  "data-test-id": "network-error-temporarily-unavailable",
  title: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "payments.errorState.temporarilyUnavailable.title"
  }),
  message: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "payments.errorState.temporarilyUnavailable.text"
  })
});
const NetworkErrorPage = ({
  statusCode,
  getCustomStatusContent,
  companyName,
  supportEmail,
  supportPhone
}) => {
  if (statusCode === 500) {
    return /*#__PURE__*/_jsx(FullPageError, {
      companyName: companyName,
      supportEmail: supportEmail,
      supportPhone: supportPhone
    });
  }
  const customStatusContent = getCustomStatusContent === null || getCustomStatusContent === void 0 ? void 0 : getCustomStatusContent(statusCode);
  if (customStatusContent) {
    return /*#__PURE__*/_jsx(ErrorStatePage, Object.assign({
      "data-test-id": "network-error-custom"
    }, customStatusContent));
  }
  return /*#__PURE__*/_jsx(EmptyStateError, {});
};
export default NetworkErrorPage;